import type { PermissionGroup } from '../models/types';

export const PERMISSION_GROUPS: PermissionGroup[] = [
  {
    category: 'Dashboard',
    permissions: [
      { id: 'view_dashboard', name: 'View Dashboard', description: 'Can view the main dashboard and stats.' },
      { id: 'view_finance', name: 'View Finance', description: 'Can view financial data and charts.' },
    ],
  },
  {
    category: 'Merchants',
    permissions: [
      { id: 'manage_merchants', name: 'Manage Merchants', description: 'Can create, edit, and delete merchants.' },
      { id: 'view_merchants', name: 'View Merchants', description: 'Can view merchant lists and details.' },
      { id: 'manage_mids', name: 'Manage MIDs', description: 'Can create and configure MIDs.' },
    ],
  },
  {
    category: 'Transactions',
    permissions: [
      { id: 'view_transactions', name: 'View Transactions', description: 'Can view all transaction logs.' },
      { id: 'refund_transactions', name: 'Refund Transactions', description: 'Can process refunds for transactions.' },
      { id: 'monitor_risk', name: 'Risk Monitoring', description: 'Can access risk and fraud detection tools.' },
    ],
  },
  {
    category: 'Users & Roles',
    permissions: [
      { id: 'manage_users', name: 'Manage Users', description: 'Can invite, edit, and disable users.' },
      { id: 'manage_roles', name: 'Manage Roles', description: 'Can create and modify roles and permissions.' },
    ],
  },
];

export const ROLES = [
  'Super Admin',
  'Admin',
  'Finance Manager',
  'Compliance Officer',
  'Support Agent',
  'Merchant',
  'Read Only',
];

export const ROLE_OPTIONS = ROLES.map((role) => ({ value: role, label: role }));
